/**
 * O backend devolve mensagens de validação (pt-BR) e de exceção em
 * `graphQLErrors`, a primeira sendo a mais específica. Erros de rede não
 * têm mensagem amigável, então caem no fallback.
 */
export const getGraphQLErrorMessage = (error, fallback) => {
    const graphQLErrors = (error && error.graphQLErrors) || [];

    return graphQLErrors.length > 0 ? graphQLErrors[0].message : fallback;
};
